const token = {
  get: type => {
    const item = window.localStorage.getItem(type || 'application:token');
    return item;
  },
  remove: type => {
    const item = window.localStorage.removeItem(type || 'application:token');
    return item;
  },
  set: (newToken, type) => {
    const item = window.localStorage.setItem(type || 'application:token', newToken);
    return item;
  },
};

export default token;
